import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { TEXT_BY_TYPE_SCORE } from '.'
import { UseTypeFontSize } from '../../../common/hooks/useTypeFontSize'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import { Table } from '../../../common/table'
import { getFontSize } from '../../../helpers/fontSize'
import { HandleDetail } from '../../common/handleDetail'
import { selectPeriod } from '../../common/period/slice'
import { VALUE_SCORE } from '../constant'
import { selectScoreActive } from '../store/slice'
import { LevelName } from './schema/LevelName'
import { getDataTable, getDataTablePer } from './store/slice'

export const TableItem = ({ isDynamicReport, type }) => {
  const dataTableRisk = useSelector(getDataTable)
  const dataTablePer = useSelector(getDataTablePer)
  const { value: typeValueStore } = useSelector(selectScoreActive)
  const period = useSelector(selectPeriod)
  const typeFontSize = UseTypeFontSize()

  const typeValue = isDynamicReport ? type : typeValueStore
  const dataTable =
    typeValue === VALUE_SCORE.CREDIT_SCORE ? dataTableRisk : dataTablePer

  const dataValue = {
    tableName: TEXT_BY_TYPE_SCORE[typeValue].tableName,
    data: dataTable,
  }

  const { tableName, data } = dataValue

  const mapData = data.map((item, index) => ({
    ...item,
    index,
  }))

  if (isDynamicReport && !mapData.length) {
    return <Notification isDynamicReport />
  }

  return (
    <>
      <Table
        ids={mapData.map((i) => i.index)}
        schema={[
          {
            colId: 'name',
            title: tableName,
            isI18n: true,
            tdStyle: { width: '100%' },
            render: (_, { rowId }) => {
              return (
                <>
                  {mapData[rowId]?.isTotal ? (
                    <Element
                      className="fw600"
                      style={{
                        paddingLeft: getFontSize(13, typeFontSize) + 8,
                      }}
                    >
                      <Translate value={mapData[rowId].name} />
                    </Element>
                  ) : (
                    <LevelName
                      val={mapData[rowId].name}
                      typeValue={typeValue}
                    />
                  )}
                </>
              )
            },
          },
          {
            colId: 'value',
            title: 'portfolio.summary.NUMBER_OF_COMPANIES',
            isI18n: true,
            tdStyle: { textAlign: 'right' },
            render: (_, { rowId }) => {
              if (mapData[rowId]?.isTotal) {
                return (
                  <HandleDetail
                    path="PortfolioInsights/ScoreRangeDetails"
                    otherParams={{
                      timeFrequency: period,
                      modelId: typeValue,
                    }}
                    style={{
                      color: isDynamicReport ? '#3A414B' : '#0553A5',
                      fontWeight: 600,
                    }}
                  >
                    {mapData[rowId].value}
                  </HandleDetail>
                )
              }
              return (
                <HandleDetail
                  path="PortfolioInsights/ScoreRangeDetails"
                  otherParams={{
                    timeFrequency: period,
                    scoreRangeId: mapData[rowId].scoreRangeId,
                    modelId: typeValue,
                  }}
                  isDynamicReport={isDynamicReport}
                >
                  {mapData[rowId].value}
                </HandleDetail>
              )
            },
          },
          {
            colId: 'percent',
            title: 'portfolio.summary.PERCENT_OF_TOTAL_COMPANIES',
            isI18n: true,
            tdStyle: { textAlign: 'right' },
            render: (_, { rowId }) => {
              return (
                <div
                  style={{
                    fontWeight: mapData[rowId]?.isTotal ? 600 : 400,
                  }}
                >
                  {mapData[rowId]?.percent?.toFixed(0)}%
                </div>
              )
            },
          },
        ]}
        autoHeightMax={500}
      />
    </>
  )
}

TableItem.propTypes = {
  isDynamicReport: PropTypes.bool,
}

TableItem.defaultProps = {
  isDynamicReport: false,
}
